import http from '../http'

export default {
  getMessages (chatId) {
    return http.get(`/chatmessage/${chatId}`)
  },
  sendMessage (message) {
    return http.post('/chatmessage/send', message)
  },
  resolveChat (session) {
    return http.post('/chatmessage/resolve', session)
  },
  startChat (session) {
    return http.post('/chatmessage/start_chat', session)
  },
  reOpenChat (session) {
    return http.post('/chatmessage/reopen_chat', session)
  },
  getChat (chatId) {
    return http.get(`/chat/${chatId}`)
  },
  resolveChatBySessionId (sessionId) {
    return http.get(`chatmessage/resolve/${sessionId}`)
  },
  moveChatToCM (session) {
    return http.post('/chatmessage/move_to_cm', session)
  }
}
